import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidenavComponent } from './sidenav.component';
import { SvgIconModule } from '../shared/svg-icon/svg-icon.module';
import { RouterModule } from '@angular/router';
import { ToggleButtonModule } from 'app/shared/toggle-button/toggle-button.module';
import { CheckboxModule } from 'app/shared/checkbox/checkbox.module';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ThirdPartyService } from 'app/third-party/third-party.service';

@NgModule({
  declarations: [SidenavComponent],
  providers: [ThirdPartyService],
  imports: [
    CommonModule,
    RouterModule,
    SvgIconModule,
    ToggleButtonModule,
    CheckboxModule,
    FormsModule,
    NgbTooltipModule,
  ],
  exports: [SidenavComponent],
})
export class SidenavModule {}
